import { motion } from "framer-motion";
import { Waveform, MagnifyingGlass, Lightning, ListChecks, CheckSquare } from "@phosphor-icons/react";

const STAGE_META = {
  init: { label: "INITIALIZING PIPELINE", icon: Lightning, step: 1 },
  video_analysis: { label: "EXTRACTING AUDIO · WHISPER TRANSCRIBING", icon: Waveform, step: 2 },
  claim_detection: { label: "DETECTING VERIFIABLE CLAIMS", icon: ListChecks, step: 3 },
  verification: { label: "SEARCHING AUTHORITATIVE SOURCES", icon: MagnifyingGlass, step: 4 },
  synthesis: { label: "SYNTHESIZING VERDICTS", icon: CheckSquare, step: 5 },
};

export default function PipelineIndicator({ stage, message, active }) {
  const meta = STAGE_META[stage] || STAGE_META.init;
  const Icon = meta.icon;

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid="pipeline-indicator"
      className="flex items-center gap-3 border-2 border-black bg-white px-4 py-3"
    >
      <span className={`w-2.5 h-2.5 rounded-full ${active ? "bg-emerald-500 pulse-dot" : "bg-zinc-300"}`} />
      <Icon weight="duotone" className="w-4 h-4 text-zinc-900" />
      <div className="flex-1 min-w-0">
        <div className="font-mono-plex text-[10px] text-zinc-500 font-semibold">
          AGENT({meta.step}/5)
        </div>
        <div className="font-mono-plex text-[11px] font-bold text-zinc-950 truncate">
          {meta.label}
        </div>
      </div>
      {message && (
        <div className="hidden md:block text-[11px] text-zinc-500 font-mono-plex normal-case tracking-normal max-w-[280px] truncate">
          {message}
        </div>
      )}
    </motion.div>
  );
}
